var _style, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.5 17.5",
    style: {
      enableBackground: "new 0 0 17.5 17.5"
    },
    xmlSpace: "preserve",
    color: "#262A3E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.logs-svg{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "logs-svg",
    d: "M0.8,1.9c0-0.6,0.5-1.1,1.1-1.1h13.8c0.6,0,1.1,0.5,1.1,1.1v3.9c0,0.6-0.5,1.1-1.1,1.1H1.9 c-0.6,0-1.1-0.5-1.1-1.1V1.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "logs-svg",
    d: "M0.8,11.8c0-0.6,0.5-1.1,1.1-1.1h13.8c0.6,0,1.1,0.5,1.1,1.1v3.9c0,0.6-0.5,1.1-1.1,1.1H1.9 c-0.6,0-1.1-0.5-1.1-1.1V11.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "logs-svg",
    d: "M13.4,1v5.5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "logs-svg",
    d: "M13.4,11v5.5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogs);
export default __webpack_public_path__ + "static/media/logs.8bfc88dfb66dd412e472ae55f243738f.svg";
export { ForwardRef as ReactComponent };